import { usePathname, useSearchParams } from "next/navigation";
import Footer from "./FooterComponent";
import Footer2 from "./FooterComponent/footer2";

import { useAppContext } from "@thriwe-2-0/thriwe-ui-utils";
import { useClientConfigProvider } from "../config/client-config-provider";

export default function MainComponentPreAuth({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathName = usePathname();
  const {
    state: { isMobile },
  } = useAppContext();

  const { config } = useClientConfigProvider();
  const footerConfig = config?.footer;

  const shouldShowFooter =
    config?.preLoginFooterHidden !== true &&
    !footerConfig?.excludedRoutes?.includes(pathName) &&
    !(isMobile
      ? footerConfig?.hiddenOnMobileRoutes?.includes(pathName)
      : footerConfig?.hiddenOnDesktopRoutes?.includes(pathName));

  return (
    <div
      className={pathName === "/landing" ? "pageWrapper" : ""}
      style={{
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        className="pageHeader"
        style={{
          position: "fixed",
          width: "100%",
          zIndex: 10,
        }}
      >
        {/* <Header /> */}
      </div>
      <div className="indexPageInnerContainer">{children}</div>
      {shouldShowFooter && (
        <div>{footerConfig?.isShowCustomFooter ? <Footer2 /> : <Footer />}</div>
      )}
    </div>
  );
}
